module.exports = {"652801001":"团结街道","652801002":"萨依巴格街道","652801003":"天山街道","652801004":"新城街道","652801005":"建设街道","652801006":"朝阳街道","652801007":"梨香街道","652801100":"塔什店镇","652801101":"上户镇","652801102":"库尔勒市西尼尔镇","652801200":"铁克其乡","652801201":"恰尔巴格乡","652801202":"英下乡","652801203":"库尔勒市兰干乡","652801204":"和什力克乡","652801205":"哈拉玉宫乡","652801206":"阿瓦提乡","652801207":"库尔勒市托布力其乡","652801208":"普惠乡","652801400":"库尔楚园艺场","652801401":"包头湖农场","652801402":"普惠农场","652801403":"巴州阿瓦提农场","652801404":"巴州沙依东园艺场","652801408":"巴州奶牛场","652801409":"普惠牧场","652801410":"经济牧场","652801411":"良种场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652801.json
// module id = 3223
// module chunks = 0